<template>
  <div class='lt-fyf-question_back_button_container'>
    <button @click="onHandleBack()" aria-label="Go back to the previous page" class='lt-fyf-question_back_button'>
      Back
    </button>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'activeItem',
    ]),
  },
  methods: {
    ...mapMutations([
      'goToPreviousPage',
      'resetScene',
    ]),
    ...mapActions([
      'resetLastItem',
    ]),
    onHandleBack() {
      if (this.activeItem.name) {
        // undo current selection
        this.resetLastItem();
      } else {
        this.goToPreviousPage();
      }
    },
  }
}
</script>

<style lang="scss">
.lt-fyf-question_back_button_container {
  display: flex;
  justify-content: center;
  text-align: center;
  margin: 24px;
  display: flex;
}

.lt-fyf-question_back_button {
  margin-bottom: auto;
  color: white;
  display: block;
  padding: 0.5rem 0.75rem;
  background: #316bac;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border: none;
  position: relative;
  cursor: pointer;
}
</style>
